// paths
export const PATH_PAIR = '/pair';
export const PATH_PURCHASE = '/';
export const PATH_REFUND = '/refund';
export const PATH_TERMINALS = '/terminals';
export const PATH_PAY_NOW = '/paynow';
export const PATH_CASH_OUT = '/cashout';
export const PATH_ORDER_FINISHED = '/order-finished';
export const PATH_HOME = '/';
export const PATH_PIN = '/pin';
export const PATH_LOGIN = '/login';


// link names
export const TEXT_FLEET_SETTINGS = 'Fleet settings';
export const TEXT_PAIR = 'Pairing';
export const TEXT_PAY_AT_TABLE = 'Pay at Table';
export const TEXT_PRE_AUTH = 'Preauthorisation';
export const TEXT_PURCHASE = 'Purchase';
export const TEXT_REFUND = 'Refund';
export const TEXT_CASHOUT = 'Cashout';
export const TEXT_TERMINALS = 'Terminals List';
export const TEXT_LOGIN = 'Login';
export const TEXT_PIN = 'Pin';
